import { useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";

/**
 * Globally captures ?ref=<user_id> on any URL and stashes it in localStorage
 * so the Register page can credit the referrer on signup. Silent, mounts once.
 */
export default function RefCapture() {
  const [params] = useSearchParams();
  const loc = useLocation();
  useEffect(() => {
    const ref = params.get("ref");
    if (!ref) return;
    try {
      localStorage.setItem("dealhub.ref", ref);
      // If the ref was clicked on a deal detail, stash that too for accurate attribution
      const m = loc.pathname.match(/^\/deals\/([^/]+)/);
      localStorage.setItem("dealhub.ref_deal", m ? m[1] : "");
    } catch (e) { /* ignore */ }
  }, [params, loc.pathname]);
  return null;
}
